module.exports = __webpack_public_path__ + "static/media/category-hero-bg.ed030691.png";